export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3535.b64c7377.jpg";